import { baseApi } from '@app/store/index.api';

import { IRequestDepositResponse } from '../model/types';

const requestDepositApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    requestDepositFilter: builder.query<IRequestDepositResponse, string>({
      query: query => {
        return {
          url: `/requests/deposits/filter?${query}`,
        };
      },
    }),
    requestDeposit: builder.query<IRequestDepositResponse, string>({
      query: query => {
        return {
          url: `/requests/deposits?${query}`,
        };
      },
    }),
  }),
});

export const { useRequestDepositQuery, useLazyRequestDepositFilterQuery } = requestDepositApi;
